import '@expo/metro-runtime';
import React, { lazy, Suspense } from 'react';
import { usePreventPageZoom } from 'src/hooks/usePreventPageZoom';
import { TRouteComponent } from './_shared/routes.types';
import { PageLoader } from '@photosi/rn-components/page-loader/PageLoader';

const UploadSmartphoneApp = lazy(() => import('src/screen/upload-smartphone/UploadSmartphoneApp'));

export const UploadSmartphoneRoute: TRouteComponent = ({ route }) => {
  usePreventPageZoom();

  return (
    <Suspense fallback={<PageLoader />}>
      <UploadSmartphoneApp token={route.params.shareToken} origin={route.params.origin} />
    </Suspense>
  );
};
